import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "./useAuth";
import FormLoginSSO from "../forms/form_login/FormLoginSSO";
import LoaderSpin from "../loaderSpin/LoaderSpin";

const AuthGuard = (props) => {
  const { children } = props;
  const { isAuthenticated, isAuthorized, isLoading } = useAuth();
  const location = useLocation();

  console.log("AuthGuard:", { isAuthenticated, isAuthorized, isLoading });

  // 1) Always wait first (MSAL redirect/claims hydration)
  if (isLoading) {
    return <LoaderSpin isVisible={true} />;
  }

  // 2) Not authenticated -> login
  if (!isAuthenticated) {
    localStorage.setItem("lastKnownPath", location.pathname + location.search);
    return <FormLoginSSO />;
  }

  // 3) Authenticated but not authorized
  if (isAuthorized === false) {
    return <Navigate to="/auth/unauthorized" replace />;
  }

  // 4) Authenticated and authorized
  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;